import type { User } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';

type AisIdentity = { vendor: string; sub: string };

export const aisIdentityOf = (user: User | null | undefined): AisIdentity | null => {
  const profile = user?.profile as { ais_vendor?: string; ais_sub?: string } | undefined;
  return profile?.ais_vendor && profile.ais_sub ? { vendor: profile.ais_vendor, sub: profile.ais_sub } : null;
};

// The vendor's pages that may hand a link into this tab
export const aisOriginsOf = (user: User | null | undefined): string[] =>
  (user?.profile as { ais_origins?: string } | undefined)?.ais_origins?.split(' ').filter(Boolean) ?? [];

export const useAisIdentity = (): AisIdentity | null => aisIdentityOf(useAuth().user);
